	//
	//
	//PROMO BAR
	//
	//
	var promo_bars = $('.cmz-banners').children();
	var curr_bar = 0;
	if(promo_bars.length>0){
		barLoop();
		setInterval(barLoop, 7000);
	}
	function barLoop(){
		$('.cmz-banner').hide();
		$(promo_bars[curr_bar]).css('display', 'block');
		curr_bar = curr_bar==promo_bars.length-1 ? 0 : curr_bar+1;
	}

	//
	//
	// HEADER
	//
	//
	var header_height, menu_height, scrollTop;
	menu_height = $('.cmz-header-menu').height();
	updateHeader();
	//$(window).scroll(updateHeader);
	function updateHeader(){
		scrollTop = window.pageYOffset || document.documentElement.scrollTop;
		//$('.cmz-header-menu, .cmz-header-menu .cmz-row').css({height: (menu_height-scrollTop)+'px'});
		$('.cmz-header-filler').css({height: ($('.cmz-header-menu').height()+$('.cmz-banners').height())+'px'});
	}
	
	//$.removeCookie('charlie_popover_signup', { path: '/' });
	//console.log('cookie: '+$.cookie('charlie_popover_signup'));
	$('.popup_close, #popup_bg').click(function(){
		//close charlie_popover_signup, dont show again for 1 day
		$('#popup_signpup, #popup_bg').hide();
		$.cookie('charlie_popover_signup', 'true', { expires: 1, path: '/' });
	});
	//check if user has cookie
	if($.cookie('charlie_popover_signup')==undefined){
		//no cookie, show charlie_popover_signup
		//$('#popup_signpup, #popup_bg').delay( 12000 ).fadeIn( 500 );
	}
	$('#popup_signpup #sign_up').click(function(){
        if($('#popup_signpup .email').val() != ''){
            $.cookie('charlie_popover_signup', 'true', { expires: 365, path: '/' });
        }
	});
	
	$.removeCookie('charlie_popover_cart', { path: '/' });
	//console.log('cookie: '+$.cookie('charlie_popover_cart'));
	$('.popup_cart_close, #popup_cart_bg').click(function(){
		//close charlie_popover_signup, dont show again for 1 day
		$('#popup_cart, #popup_cart_bg').hide();
		$.cookie('charlie_popover_cart', 'true', { expires: 1, path: '/' });
	});
	//check if user has cookie
	if($.cookie('charlie_popover_cart')==undefined){
		//no cookie, show charlie_popover_signup
		//$('#popup_cart, #popup_cart_bg').delay( 1000 ).fadeIn( 300 );
	}
	
	//
	//
	// TOOLTIPS
	//
	//
	tippy('.cmz-thumbnail-quickie-eye', {
		delay: 0,
		arrow: false,
		arrowType: 'sharp',
		placement: 'left',
		size: 'small',
		offset: '0,0',
		distance: 5,
		animation: 'fade',
		duration: [0,0]
	});
	/*tippy('.cmz-email-me', {
		delay: 0,
		arrow: false,
		arrowType: 'sharp',
		placement: 'left',
		size: 'small',
		offset: '0,0',
		distance: 5,
		animation: 'fade',
		duration: [0,0]
	});*/
	
	
	
	
	
	//
	//
	// MENUS
	//
	//
	
	//close dropdowns
	function closeDrops(_exclude){
		if($('.cmz-nav').hasClass('active') && _exclude != 'nav') toggleNav();
		if($('.cmz-search').hasClass('active') && _exclude != 'search') toggleSearch();
		if($('.cmz-account-dropdown').hasClass('active') && _exclude != 'account') toggleAccount();
		if($('.cart_dropdown').hasClass('active') && _exclude != 'cart') toggleCart();
	}
	
	//open close nav
	if($('html').hasClass('supports-touch')){
		$('.cmz-shop-btn').click(function(){
			closeDrops('nav');
			toggleNav()
		});
	}else{
		$('.cmz-shop-btn, .cmz-nav-box').hover(() => toggleNav(), () => toggleNav());
	}
	function toggleNav(){
		$('.cmz-shop-btn a').toggleClass('active');
		$('.cmz-shop-btn .cmz-header-arrow').toggleClass('down');
		$('.cmz-nav').toggleClass('active');
	}
	
	//open close nav on mobile
	$('.cmz-shop-btn-mobile').click(function(){
		if($('.cart_dropdown').hasClass('active')){
			$('.cmz-cart-btn-mobile').trigger('click');
		}
		$(this).toggleClass('open');
		$('.cmz-nav').toggleClass('active');
	});
	
	//open close nav sections on mobile
	$('.cmz-nav-item .cmz-nav-header').click(function(){
		if($('.cmz-shop-btn-mobile').hasClass('open')){
			if($(this).hasClass('active')){
				$(this).parent().find('li').slideToggle('fast');
				$(this).find('.cmz-nav-arrow').removeClass('down');
				$(this).removeClass('active');
			}else{
				$(this).parent().find('li').slideToggle('fast');
				$(this).find('.cmz-nav-arrow').addClass('down');
				$(this).addClass('active');
			}
		}
	});
	
	//open close search
	if($('html').hasClass('supports-touch')){
		$('.cmz-header-search-btn').click(function(){
			closeDrops('search');
			toggleSearch()
		});
	}else{
		$('.cmz-header-search-btn, .cmz-search').hover(() => toggleSearch(), () => toggleSearch());
	}
	function toggleSearch(){
		$('.cmz-header-search-btn a').toggleClass('active');
		$('.cmz-search').toggleClass('active');
	}
	
	//open close account
	if($('html').hasClass('supports-touch')){
		$('.cmz-header-account-btn').click(function(){
			closeDrops('account');
			toggleAccount()
		});
	}else{
		$('.cmz-header-account-btn, .cmz-account-dropdown').hover(() => toggleAccount(), () => toggleAccount());
	}
	function toggleAccount(){
		$('.cmz-header-account-btn a').toggleClass('active');
		$('.cmz-account-dropdown').toggleClass('active');
	}
	
	//open close cart
	if($('html').hasClass('supports-touch')){
		$('.cmz-header-cart-btn').click(function(e){
			e.preventDefault();
			closeDrops('cart');
			toggleCart();
		})
	}else{
		if(window.location.pathname!="/cart"){
			$('.cmz-header-cart-btn, .cart_dropdown').hover(() => toggleCart(1), () => toggleCart(2));
		}
	}
	function toggleCart(_manual = 0){
		if(_manual==1){
			$('.cmz-header-cart-btn a').addClass('active');
			$('.cart_dropdown').addClass('active');
		}else if(_manual==2){
			$('.cmz-header-cart-btn a').removeClass('active');
			$('.cart_dropdown').removeClass('active');
		}else{
			$('.cmz-header-cart-btn a').toggleClass('active');
			$('.cart_dropdown').toggleClass('active');
		}
		
	}
	
	//open close cart on mobile
	$('.cmz-cart-btn-mobile').click(function(){
		if($('.cmz-nav').hasClass('active')){
			$('.cmz-shop-btn-mobile').trigger('click');
		}
		$('.cart_dropdown').toggleClass('active');
	});
	
	//
	//
	// DYNAMIC CART
	//
	//
	
	//get cart
	var current_cart;
	var item_count = 0;
	
	GetCart();
	
	function GetCartOld(){
		$.ajax({
            url: '/cart.js',
            type: 'get',
			dataType: 'json',
            success: function (data) {
				console.log("--- default ---");
				console.log(data);
				UpdateCartDisplay(data);
            }
        });
	}
	
	//note the URL, this returns a custom version of the cart json object, mostly to include the metafeilds
	function GetCart(){
		$.ajax({
            url: '/cart?view=data.json',
            type: 'get',
            success: function (data) {
				//console.log("--- custom ---");
				//console.log(JSON.parse(data));
				UpdateCartDisplay(JSON.parse(data));
            }
        });
	}
	function UpdateCartDisplay(_data){
		//console.log(_data);
		
		current_cart = _data.items;
		item_count = _data.item_count;
		
		$('.cart_dropdown_items').empty();
		
		if(item_count>0){
			if(item_count>6){
				$('.cart_dropdown_items').append(
					'<li style="background:#dbb729; margin-bottom: 20px;">'+
						'<a class="button cart_dropdown_checkout" href="/cart">CHECKOUT</a>'+
					'</li>'
				);
			}
			//update cart dropdown line items
			for(var i=0; i<_data.items.length; i++){
				$('.cart_dropdown_items').append(
					'<li data-id="'+current_cart[i].variant_id+'">'+
		  				'<ul class="cart_dropdown_item">'+
		  					'<li class="cart_dropdown_image"><img src="'+ImgToSize(current_cart[i].image, "50x")+'" /></li>'+
							'<li class="cart_dropdown_title"><a href="'+current_cart[i].url+'">'+current_cart[i].title+'</a></li>'+
							'<li class="cart_dropdown_quantity"><input class="cart_quantity cart_quantity_update" type="text" onkeypress="return event.charCode >= 48 && event.charCode <= 57" data-id="'+current_cart[i].variant_id+'" value="'+current_cart[i].quantity+'"/></li>'+
							'<li class="cart_dropdown_price">'+NumToPrice(current_cart[i].line_price.toString())+'</li>'+
							'<li class="cart_dropdown_remove">'+
								'<span class="cart_remove" data-id="'+current_cart[i].variant_id+'" title="Remove Item">X</span>'+
							'</li>'+
		  				'</ul>'+
					'</li>'
				);
				//update cart page line items
				$('.cmz-cart li[data-id="'+current_cart[i].variant_id+'"] .cart_dropdown_price_total')
					.html(NumToPrice(current_cart[i].line_price.toString()));
			}
			
			//update cart dropdown totals
			$('.cart_dropdown_items').append(
				'<li>'+
					'<ul class="cart_dropdown_item">'+
						'<li class="cart_dropdown_image">&nbsp;</li>'+
						'<li class="cart_dropdown_title">&nbsp;</li>'+
						'<li class="cart_dropdown_quantity"><input class="cart_quantity cart_quantity_update" type="text" value=" "/></li>'+
						'<li class="cart_dropdown_price" style="border-top:1px solid black; padding:15px 10px 20px 0;">'+NumToPrice(_data.total_price.toString())+'</li>'+
						'<li class="cart_dropdown_remove" style="color:white">X</li>'+
					'</ul>'+
				'</li>'+
				'<li style="background:#dbb729">'+
					'<a class="button cart_dropdown_checkout" href="/cart">CHECKOUT</a>'+
				'</li>'
			);
			
			
			
			//TODO: test this on the actual cart element rather than a test element
			//this is replicating the elements on the cart.liquid page
			if(window.location.pathname=="/cart"){
				$('.cmz-cart-items').empty();
				//update cart page line items
				for(var i=0; i<_data.items.length; i++){
					var el = "";
					el += '<li data-id="'+current_cart[i].variant_id+'">'+
							'<ul class="cart_dropdown_item">'+
								'<li class="cart_dropdown_image"><img src="'+ImgToSize(current_cart[i].image, "100x")+'" /></li>'+
								'<li class="cart_dropdown_title">'+
									'<a href="'+current_cart[i].url+'">'+
										'<div class="cart_product_name" data-product-id="'+current_cart[i].id+'">'+current_cart[i].product_title+'</div>'+
										'<div class="cart_dropdown_style">'+current_cart[i].metafields.charlie_product.description+'</div>'+
									'</a>';
                                  if(current_cart[i].variant_title != 'Default Title'){
									el +='<div class="cart_dropdown_size">'+current_cart[i].variant_title+'</div>';
                                  }
								el += '</li>'+
								'<li class="cart_dropdown_price">';
							if(current_cart[i].compare_at_price_max > current_cart[i].price){
								el += '<span class="cmz-thumbnail-was_price">'+NumToPrice(current_cart[i].compare_at_price_max.toString())+'</span>'+
									'<span class="cmz-gold">'+NumToPrice(current_cart[i].price.toString())+'</span>';
							}else{
									el += NumToPrice(current_cart[i].price.toString());
							}
						   el+= '</li>'+
								'<li class="cart_dropdown_quantity">'+
									'<span class="cmz-cart-less">-</span>'+
									'<input class="cart_quantity cart_quantity_update" type="text" onkeypress="return event.charCode >= 48 && event.charCode <= 57" data-id="'+current_cart[i].variant_id+'" value="'+current_cart[i].quantity+'"/>'+
									'<span class="cmz-cart-more">+</span>'+
								'</li>'+
								'<li class="cart_dropdown_price cart_dropdown_price_total">'+NumToPrice(current_cart[i].line_price.toString())+'</li>'+
								'<li class="cart_dropdown_remove">'+
									'<span class="cart_remove" data-id="'+current_cart[i].variant_id+'" title="Remove Item">X</span>'+
								'</li>'+
							'</ul>'+
						'</li>';
					$('.cmz-cart-items').append(el);
				}
			}
			
			
			
			
			//update cart page totals
			$('.cmz-cart .cart_total').html(NumToPrice(_data.total_price.toString()));
			
			saved_total = 0;
			$('.cmz-cart .cmz-thumbnail-was_price').each(function(){
				saved_total += (parseInt($(this).html().substr(1)) - parseInt($(this).parent().find('.cmz-gold').html().substr(1))) * parseInt($(this).parent().parent().find('.cart_quantity_update').val());
			});

			if(saved_total > 0){
				$('.cmz-cart .total_saved').html("-$"+saved_total);
				$('.cmz-cart .total_original').html("$"+(parseInt($('.cmz-cart .cart_total').html().substr(1)) + saved_total));
			}else{
				$('.cmz-cart .cart_savings').hide();
			}
		}
		
		if(item_count > 0){
			$('.cart_count').html(item_count);
			$('.cmz-header-cart-btn, .cmz-cart-btn-mobile').addClass('full');
		}else{
			$('.cart_count').html("");
			$('.cmz-header-cart-btn, .cmz-cart-btn-mobile').removeClass('full');
		}
		
		
		if($(".cart_dropdown_items").children().length>0){
			$('.cart_dropdown_empty').hide();
		}else{
			$('.cart_dropdown_empty').show();
		}
		
		//delivery signature option enable/disable
		if(_data.total_price >= 30000){
			$('.cmz-cart .delivery_signature_option input').prop("disabled", false);
			$('.cmz-cart .delivery_signature_option').show();
		}else{
			$('.cmz-cart .delivery_signature_option').hide();
			$('.cmz-cart .delivery_signature_option input').prop("disabled", true);
		}
		
		//refresh cart page if all items get removed
		if(item_count==0 && window.location.pathname=="/cart" && $('.cmz-cart').length > 0){
			location.reload();
		}
	}


	//add to cart
	$(document.body).on('click', '.cmz-add-to-cart', function(){
		var $form = $(this).closest('form')
		var vid = $form.find('input[type=radio]:checked').val();
        if(!vid) vid = $form.find('.cmz-no-variant').data("value");
		var amt = 1;
		console.log(current_cart);
		if(current_cart != undefined && current_cart.length>0){
			for(var i=0; i<current_cart.length; i++){
				if(current_cart[i].variant_id==vid){
					amt = current_cart[i].quantity+1;
				}
			}
		}
		AddToCart(vid, amt);
	})
	function AddToCart(_vid, _quantity){
		//console.log("adding: "+_vid+" "+_quantity);
		$.ajax({
            url: '/cart/update.js',
            type: 'post',
            dataType: 'json',
            success: function (data) {
				current_cart = data.items;
				$('.cmz-add-to-cart').val("ADDED").addClass("added");
				$('.cmz-header-cart-btn, .cmz-cart-btn-mobile,  .cart_count').addClass('added2');
				setTimeout(() => {
					$('.cmz-add-to-cart').val("ADD TO CART").removeClass("added"); 
					$('.cmz-header-cart-btn, .cmz-cart-btn-mobile, .cart_count').removeClass('added2');
				}, 1000);
				//UpdateCartDisplay(data);
				GetCart();
            },
            data: "updates["+_vid+"]="+_quantity
        });
	}


	//remove from cart
	$(document.body).on('click', '.cart_remove', function(){
		RemoveFromCart($(this).attr('data-id'));
	});
	function RemoveFromCart(_vid){
		//console.log("removing: "+_vid);
		$.ajax({
            url: '/cart/update.js',
            type: 'post',
            dataType: 'json',
            success: function (data) {
				//console.log(data);
                $("ul li[data-id='"+ _vid +"']").css('background','grey').fadeOut( function() { 
					$(this).remove(); 
					//UpdateCartDisplay(data); 
					GetCart();
				});
				$('.cart_total').html(NumToPrice(data.total_price.toString()));
            },
            data: "updates["+_vid+"]=0"
        });
	}


	//change quantity
	$(document.body).on('change keyup', '.cart_quantity_update', function(){
		UpdateCart($(this).attr('data-id'), $(this).val());
	});
	$(document.body).on('click', '.cmz-cart-less', function(){
		$q = $(this).parent().find('.cart_quantity_update');
		v = parseInt($q.val());
		if(v>=2){
			$q.val(v-1);
			UpdateCart($q.attr('data-id'), $q.val());
		}
	});
	$(document.body).on('click', '.cmz-cart-more', function(){
		$q = $(this).parent().find('.cart_quantity_update');
		v = parseInt($q.val());
		$q.val(v+1);
		UpdateCart($q.attr('data-id'), $q.val());
	});
	function UpdateCart(_vid, _quantity){
		//console.log("adding: "+_vid+" "+_quantity);
		$.ajax({
            url: '/cart/update.js',
            type: 'post',
            dataType: 'json',
            success: function (data) {
				//UpdateCartDisplay(data);
				GetCart();
            },
            data: "updates["+_vid+"]="+_quantity
        });
	}

	//helpers
	function NumToPrice(_num){
		return "$"+_num.substring(0, _num.length-2);// + "." + _num.substring(_num.length-2);
	}
	function ImgToSize(_img, _size){
		//https://cdn.shopify.com/s/files/1/0188/9160/products/Cashmere-long-sleeve-tshirt-and-grey-pant-crop.jpg?v=1511225962
		return _img.substring(0, _img.indexOf(".jpg")) + "_" + _size + _img.substring(_img.indexOf(".jpg"), _img.length);
	}
	
	//collection quick views
	$(document).on('click', '.cmz-thumbnail-quickie', function(){
		if(!$(this).hasClass('active-quickie')){
			$('.active-quickie').closest('.cmz-thumbnail').find('.cmz-thumbnail-info:last').css('visibility', 'visible');
			$('.active-quickie').removeClass('active-quickie').parent().find('.cmz-thumbnail-quickie-box').hide();
			$(this).addClass('active-quickie').parent().find('.cmz-thumbnail-quickie-box').show();
			$(this).closest('.cmz-thumbnail').find('.cmz-thumbnail-info:last').css('visibility', 'hidden');
		}else{
			$(this).removeClass('active-quickie').parent().find('.cmz-thumbnail-quickie-box').hide();
			$(this).closest('.cmz-thumbnail').find('.cmz-thumbnail-info:last').css('visibility', 'visible');
		}
	});
	
	//
	// ON LOAD
	//
	
	$(window).load(function() {
		//init flexslider
	    $('.cmz-heros').flexslider({
			controlNav: false,
			directionNav: true,
			slideshow: true,
			animation: "fade",
			touch:true,
			prevText: "",
			nextText: ""
	    });
	});